import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { openPaymentAuthorization } from "@/lib/paymentConnectionNavigation";

const disconnected = { provider: "PAGBANK", status: "DISCONNECTED", enabled: false, can_activate: false };
const statusLabels = { DISCONNECTED: "Não conectado", PENDING: "Conectando", CONNECTED: "Conectado", ERROR: "Erro", REVOKED: "Não conectado" };

export default function PaymentConnectionPanel({ connection, reload }) {
  const [view, setView] = useState(connection || disconnected);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setView(connection || disconnected); }, [connection]);

  const perform = async (operation) => {
    setBusy(true);
    try { await operation(); }
    catch (error) { toast.error(error?.response?.data?.detail || "Não foi possível atualizar a conexão de pagamento."); }
    finally { setBusy(false); }
  };
  const connect = () => perform(async () => {
    const { data } = await api.post("/admin/payment-connection/pagbank/connect");
    setView({ ...view, enabled: false, status: "PENDING" });
    openPaymentAuthorization(data.authorization_url);
  });
  const disconnect = () => perform(async () => {
    const { data } = await api.delete("/admin/payment-connection");
    setView({ ...view, ...data, enabled: false, can_activate: false });
    await reload();
    toast.success("Conta de pagamento desconectada.");
  });
  const toggle = () => {
    if (!view.enabled && !view.can_activate) {
      toast.error("Conecte um meio de pagamento para ativar cobranças antecipadas.");
      return;
    }
    return perform(async () => {
      const { data } = await api.put("/admin/payment-connection/settings", { enabled: !view.enabled });
      setView(data);
      await reload();
    });
  };
  return <section className="card-surface mt-6 p-5 space-y-3" data-testid="payment-connection">
    <h2 className="font-sans2 font-semibold text-amber-50">Pagamentos</h2>
    <p className="text-sm text-stone-300">Cobrança antecipada: <strong data-testid="payment-collection-status">{view.enabled ? "Ativada" : "Desativada"}</strong></p>
    <p className="text-sm text-stone-300">Provedor: PagBank</p>
    <p className="text-sm text-stone-300">Status: <strong data-testid="payment-connection-status">{statusLabels[view.status] || "Não conectado"}</strong></p>
    <p className="text-sm text-stone-400">Conecte a conta do estabelecimento para gerenciar seus recebimentos.</p>
    {view.status === "CONNECTED" && view.execution_available === false && <p className="text-sm text-amber-400">Conta conectada. A cobrança por essa conta estará disponível após a validação da integração.</p>}
    {view.status === "ERROR" && <p className="text-sm text-amber-400">Não foi possível validar a conexão. Desconecte e tente conectar novamente.</p>}
    <div className="flex flex-wrap gap-3">
      {["DISCONNECTED", "REVOKED"].includes(view.status) && <button type="button" data-testid="connect-pagbank" disabled={busy} onClick={connect} className="bg-[#D4AF37] text-[#0A0B0E] px-4 py-2 rounded-lg disabled:opacity-50">Conectar PagBank</button>}
      {["CONNECTED", "PENDING", "ERROR"].includes(view.status) && <button type="button" data-testid="disconnect-pagbank" disabled={busy} onClick={disconnect} className="border border-[#D4AF37]/40 px-4 py-2 rounded-lg text-stone-300 disabled:opacity-50">Desconectar</button>}
      <button type="button" data-testid="toggle-payment-collection" disabled={busy} onClick={toggle} className="border border-[#D4AF37]/40 px-4 py-2 rounded-lg text-stone-300 disabled:opacity-50">{view.enabled ? "Desativar cobrança antecipada" : "Ativar cobrança antecipada"}</button>
    </div>
  </section>;
}
